import { ArrowDownRight } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";
import { photos } from "@/data/siteData";

export default function Signature() {
  const ref = useReveal();
  return (
    <section
      id="signature"
      ref={ref}
      data-testid="signature-section"
      className="relative py-20 md:py-28 bg-[#EBE4D8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="relative overflow-hidden bg-[#132A1C]">
              <img
                src={photos.twoVietnameseCoffees}
                alt="Vietnamese iced coffee — cà phê sữa đá — at Cafe Anh Helsinki"
                loading="lazy"
                className="w-full h-[55vh] lg:h-[68vh] object-cover transition-transform duration-700 hover:scale-[1.03]"
              />
              <div className="absolute top-5 left-5 bg-[#F4F0EA]/95 backdrop-blur px-4 py-2.5 text-[11px] tracking-[0.2em] uppercase text-[#132A1C]">
                Signature · €5.50
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 lg:pl-6">
            <p className="reveal text-[11px] tracking-[0.32em] uppercase text-[#5A7365] mb-5">
              Our signature drink
            </p>
            <h2 className="reveal font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#132A1C] leading-[1.08] tracking-tight">
              <span className="italic">Cà phê sữa đá</span> —
              <br />
              Vietnamese iced coffee.
            </h2>
            <div className="reveal mt-7 space-y-5 text-[#2C4C3B] leading-relaxed text-base md:text-lg max-w-xl">
              <p>
                In Vietnam, coffee is not a quick errand. It's a moment — a small
                metal phin filter, dark robusta drip by drip, condensed milk pooling
                at the bottom of the glass.
              </p>
              <p>
                We brew the same way at Cafe Anh: slow, strong, sweet, served over
                ice. One sip and you'll understand why this little glass travelled
                with us from Saigon to Hämeentie.
              </p>
            </div>

            <div className="reveal mt-9 flex flex-wrap items-center gap-3">
              <a
                href="#menu"
                data-testid="signature-cta-menu"
                className="group inline-flex items-center gap-3 px-6 py-3.5 bg-[#132A1C] text-[#F4F0EA] text-[12px] tracking-[0.22em] uppercase hover:bg-[#0D1E13] transition-colors"
              >
                Full menu
                <ArrowDownRight
                  size={15}
                  strokeWidth={1.5}
                  className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1"
                />
              </a>
              <span className="text-[11px] tracking-[0.22em] uppercase text-[#5A7365]">
                Hot phin · Iced · Takeaway
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
